<template>
  <div class="practice-areas">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 顶部大图 -->
      <section class="banner-section">
        <img src="@/assets/images/homepage2.png" alt="服务范围" class="banner-image">
        <div class="banner-overlay">
          <h1 class="banner-title">{{ $t('practice.banner.title') }}</h1>
          <p class="banner-subtitle">{{ $t('practice.banner.subtitle') }}</p>
        </div>
      </section>


      <!-- 服务领域介绍 -->
      <section class="practice-intro">
        <div class="container">
          <p class="intro-text" style="font-weight: bold;">
            {{ $t('practice.intro.title') }}
          </p>
        </div>
      </section>

      <!-- 服务卡片 -->
      <section class="services-cards-section">
        <div class="container">
          <div class="services-grid">
            <div class="service-card" v-for="(service, index) in services" :key="index">
              <div class="card-header">
                <h3 class="card-title">{{ getServiceTitle(index) }}</h3>
              </div>
              <div class="card-body">
                <ul class="card-text">
                  <li v-for="(desc, i) in service.descriptions" :key="i" v-html="getServiceDesc(index, i)"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新增一个案例 -->
      <!-- 授权周期快模块 -->
      <section class="fast-authorization-section">
        <div class="container">
          <div class="section-header">
            <h2 class="authorization-title">{{ $t('practice.cases.fast.title') }}</h2>
          </div>

          <div class="authorization-grid">
            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli101.png" alt="预审合格" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.preExam') }}</h3>
              </div>
            </div>

            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli102.png" alt="发文情况" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.sendStatus') }}</h3>
              </div>
            </div>

            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli103.png" alt="授权公告文本首页" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.firstPage') }}</h3>
              </div>
            </div>
          </div>
          <div class="showcase-cta">
            <el-button type="primary" size="large" class="cta-button" @click="goToContact(1)">
              <i class="el-icon-s-promotion"></i>
              {{ $t('practice.learnMore') }}
            </el-button>
          </div>
        </div>
      </section>
      <!-- 授权授权周期慢模块 -->
      <section class="fast-authorization-section">
        <div class="container">
          <div class="section-header">
            <h2 class="authorization-title">{{ $t('practice.cases.slow.title') }}</h2>
          </div>

          <div class="authorization-grid">
            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli201.png" alt="预审合格" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.reexamWithdraw0') }}</h3>
              </div>
            </div>

            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli202.png" alt="发文情况" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.reexamWithdraw') }}</h3>
              </div>
            </div>

            <div class="authorization-item">
              <div class="auth-image">
                <img src="@/assets/images/fuwu/anli203.png" alt="授权公告文本首页" class="auth-img">
              </div>
              <div class="auth-content">
                <h3 class="auth-text">{{ $t('practice.cases.labels.reexamWithdraw2') }}</h3>
              </div>
            </div>
          </div>
          <div class="showcase-cta">
            <el-button type="primary" size="large" class="cta-button" @click="goToContact(2)">
              <i class="el-icon-s-promotion"></i>
              {{ $t('practice.learnMore') }}
            </el-button>
          </div>
        </div>
      </section>

      <!-- 药品专利链接制度 -->
      <section class="pharma-patent-section" v-if="false">
        <div class="container">
          <div class="section-header">
            <h2 class="pharma-title">{{ $t('practice.pharma.title') }}</h2>
          </div>

          <div class="pharma-description">
            <p class="description-text" v-html="$t('practice.pharma.description')"></p>
          </div>

          <div class="certificates-grid">
            <div class="certificate-item">
              <div class="certificate-image">
                <img :src="certificate1" alt="KES Pharma GmbH感谢函" class="cert-img">
              </div>
              <div class="certificate-caption">
                <p class="cert-text">{{ $t('practice.textn1') }}</p>
              </div>
            </div>

            <div class="certificate-item">
              <div class="certificate-image">
                <img :src="certificate2" alt="北京天衡药物研究院感谢函" class="cert-img">
              </div>
              <div class="certificate-caption">
                <p class="cert-text">{{ $t('practice.textn2') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  <OverviewShowcaseGroup   :showcaseImgVariant="2"/>
      
    </main>

    <!-- 页脚 -->
    <Footer />
    <!-- 联系我们弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="70%" :show-close="false" top="1vh" custom-class="contact-dialog">
      <div class="dialog-content">
        <div class="dialog-header">
          <h2 class="dialog-title" v-show="anliNum == 1">{{ $t('practice.cases.fast.title') }}</h2>
          <h2 class="dialog-title" v-show="anliNum == 2">{{ $t('practice.cases.slow.title') }}</h2>
        </div>
        <div class="dialog-header" v-show="anliNum == 3">
          <h2 class="dialog-title" style="color: red;">小词酿大祸：专利翻译误区案例剖析</h2>
          <p class="dialog-subtitle"> </p>
        </div>
        <div class="dialog-body">
          <div class="image-gallery">
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[0].image) || (anliNum === 2 && showcase2Items[0].image)
                " alt="初步咨询" class="gallery-image">
              <div class="item-caption"> {{ anliNum == 1 ? $t('practice.cases.labels.preExam') : $t('practice.cases.labels.sendStatus') }}</div>
            </div>
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[1].image) || (anliNum === 2 && showcase2Items[1].image)
                " alt="初步咨询" class="gallery-image">
              <div class="item-caption"> {{ anliNum == 1 ? $t('practice.cases.labels.sendStatus') : $t('practice.cases.labels.reexamWithdraw') }} </div>
            </div>
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[2].image) || (anliNum === 2 && showcase2Items[2].image)
                " alt="成功授权" class="gallery-image">
              <div class="item-caption">{{ $t('practice.cases.labels.firstPage') }} </div>
            </div>
          </div>
          <div class="text-content" v-show="anliNum == 1 || anliNum == 2 || anliNum == 22">
            <div style="font-weight:bold;font-size: 18px;color:balck"></div>
            <div v-show="anliNum == 1">
              <div> {{ $t('practice.dialoga1') }}
                <span class="highlight-blue"> {{ $t('practice.dialoga2') }}</span> {{ $t('practice.dialoga3') }}
              </div>

            </div>

            <div v-show="anliNum == 2">
              {{ $t('practice.textn3') }}
              <span class="highlight-blue"> {{ $t('practice.textn4') }}</span>
              {{ $t('practice.textn5') }}
            </div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:56px" v-show="anliNum == 1"></div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:56px" v-show="anliNum == 2"></div>
            <p v-show="anliNum == 1" style="margin-top: 8rem;">
               {{ $t('practice.dialoga4') }}
              <span class="highlight-blue"> {{ $t('practice.dialoga5') }}</span>
               {{ $t('practice.dialoga6') }}
              <span class="highlight-blue"> {{ $t('practice.dialoga7') }}</span>
            </p>

            <div v-show="anliNum == 2">
              <div> {{ $t('practice.textn6') }}<span class="highlight-blue">{{ $t('practice.textn7') }}</span></div>
              <div>① {{ $t('practice.textn8') }}</div>
              <div>② {{ $t('practice.textn9') }}</div>
              <div>③ {{ $t('practice.textn10') }}</div>

              <div style="margin-top: 1rem;">{{ $t('practice.textn11') }}
                <span class="highlight-blue">{{ $t('practice.textn12') }}</span>
              </div>
            </div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:34px" v-show="anliNum == 1"> </div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:80px" v-show="anliNum == 2"> </div>
            <p v-show="anliNum == 1" style="margin-top: 8rem;">
                {{ $t('practice.dialoga8') }}
            </p>
            <p v-show="anliNum == 2">
              <span class="highlight-blue">{{ $t('practice.textn13') }}</span>
             {{ $t('practice.textn14') }}
            </p>
          </div>

        </div>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">{{$t('closestr')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import OverviewShowcaseGroup from '@/components/OverviewShowcaseGroup'
export default {
  name: 'PracticeAreas',
  components: {
    Header,OverviewShowcaseGroup,
    Footer
  },
  data() {
    return {
      showcaseItems: [
        {
          title: '创意构思与分析',
          desc: '深入了解您的创新思路，通过专业分析确定可专利性和保护策略，为您的创意提供最佳的知识产权保护方案。',
          image: require('@/assets/images/fuwu/anli101.png')
        },
        {
          title: '专业技术制图',
          desc: '运用专业制图软件，精确绘制技术方案图纸，确保专利申请文件的技术描述清晰准确，符合审查要求。',
          image: require('@/assets/images/fuwu/anli102.png')
        },
        {
          title: '专利撰写与申请',
          desc: '资深专利代理师撰写高质量专利申请文件，全程跟踪申请流程，确保您的专利权益得到最大化保护。',
          image: require('@/assets/images/fuwu/anli103.png')
        }
      ],
      showcase2Items: [
        {
          title: '创意构思与分析',
          desc: '深入了解您的创新思路，通过专业分析确定可专利性和保护策略，为您的创意提供最佳的知识产权保护方案。',
          image: require('@/assets/images/fuwu/anli201.png')
        },
        {
          title: '专业技术制图',
          desc: '运用专业制图软件，精确绘制技术方案图纸，确保专利申请文件的技术描述清晰准确，符合审查要求。',
          image: require('@/assets/images/fuwu/anli202.png')
        },
        {
          title: '专利撰写与申请',
          desc: '资深专利代理师撰写高质量专利申请文件，全程跟踪申请流程，确保您的专利权益得到最大化保护。',
          image: require('@/assets/images/fuwu/anli203.png')
        }
      ],
      strategyImage: require('@/assets/images/teamimg/anli01.png'),
      certificate1: require('@/assets/images/teamimg/anli03.png'),
      certificate2: require('@/assets/images/teamimg/anli04.png'),
      services: [
        {
          title: '商标',
          descriptions: [
            '商标的<span class="highlight">注册咨询</span>、商标查询',
            '商标的转让、许可、变更、续展等',
            '代理<span class="highlight">商标权诉讼</span>、权属纠纷相关业务',
            '担任商标法律顾问',
            '注册商标的跟踪监控'
          ]
        },
        {
          title: '诉讼',
          descriptions: [
            '代理专利的侵权纠纷、权属纠纷、合同争议或其他纠纷',
            '代理<span class="highlight">专利权无效</span>、<span class="highlight">复审</span>和行政诉讼程序',
            '代理知识产权侵权监测，进行侵权调查取证',
            '代理行政复议申请，代理侵权案件'
          ]
        },
        {
          title: '专利',
          descriptions: [
            '优质专利申请的全程代理服务',
            '专利检索、专利申请权转让、专利的实可使用',
            '提供三性评价检索、专利分析和侵权检索及分析',
            '提供知识产权规划布局、专利地图导航服务',
            '专利预审、优先审查等专利申请加速服务'
          ]
        },
        {
          title: '知识产权、法律服务',
          descriptions: [
            '计算机软件著作权登记服务',
            '<span class="highlight">国外原产地名称、地理标志注册和登记服务</span>',
            '<span class="highlight">反不正当竞争及商业秘密保护服务</span>',
            '技术引进转让的知识产权法律服务',
            '工业设计专权',
            '<span class="highlight">Freedom To Operate</span>'
          ]
        },
        {
          title: '涉外专利',
          descriptions: [
            '<span class="highlight">PCT国际申请、巴黎公约</span>途径海外专利申请的全程代理服务',
            '海外专利检索及意见咨询',
            '专门文件翻译',
            '海外专利其他法律业务'
          ]
        },
        {
          title: '翻译',
          descriptions: [
            '提供涉及知识产权、科技和法律等多语种对外专业翻译',
            '<span class="highlight">中英</span>科技文献互译',
            '<span class="highlight">中德</span>科技文献互译',
            '<span class="highlight">中日</span>科技文献互译'
          ]
        }
      ],
      practiceAreas: [
        {
          id: 1,
          title: 'Intellectual Property',
          description: 'Protection of trademarks, patents, copyrights, designs and trade secrets. We help clients register, enforce and defend their intellectual property rights.',
          icon: 'el-icon-shield'
        },
        {
          id: 2,
          title: 'Commercial Law',
          description: 'Contract drafting, negotiation, review and dispute resolution. We assist clients with various commercial transactions and legal issues.',
          icon: 'el-icon-document'
        },
        {
          id: 3,
          title: 'Corporate Law',
          description: 'Company formation, mergers and acquisitions, corporate governance and compliance. We provide comprehensive legal support for businesses.',
          icon: 'el-icon-company'
        },
        {
          id: 4,
          title: 'Litigation & Dispute Resolution',
          description: 'Representation in court proceedings and alternative dispute resolution. We help clients resolve conflicts effectively and efficiently.',
          icon: 'el-icon-suitcase'
        },
        {
          id: 5,
          title: 'Data Protection & Privacy',
          description: 'Compliance with data protection laws, data security and privacy policies. We assist clients in protecting sensitive information.',
          icon: 'el-icon-lock'
        },
        {
          id: 6,
          title: 'Employment Law',
          description: 'Employment contracts, workplace policies, discrimination claims and termination issues. We provide guidance to both employers and employees.',
          icon: 'el-icon-users'
        }
      ], dialogVisible: false, anliNum: 1,

    }
  }, methods: {
    // 多语言服务标题
    getServiceTitle(index) {
      const keys = ['trademark', 'litigation', 'patents', 'ipLegal', 'international', 'translation']
      const key = keys[index] || keys[0]
      return this.$t(`practice.services.${key}.title`)
    },
    // 多语言服务描述
    getServiceDesc(index, i) {
      const keys = ['trademark', 'litigation', 'patents', 'ipLegal', 'international', 'translation']
      const key = keys[index] || keys[0]
      const list = this.$t(`practice.services.${key}.descriptions`)
      // Vue I18n 返回数组或字符串，确保返回对应项
      if (Array.isArray(list)) {
        return list[i] || ''
      }
      // 若未配置为数组，容错处理
      try {
        const parsed = JSON.parse(list)
        return parsed[i] || ''
      } catch (e) {
        return list
      }
    },
    goToContact(num) {
      this.anliNum = num
      this.dialogVisible = true;
    },

  }
}
</script>

<style scoped>
.practice-areas {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 33.6rem;
  overflow: hidden;
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 0 20px;
}

.banner-title {
  font-size: 42px;
  font-weight: bold;
  margin: 0 0 20px;
}

.banner-subtitle {
  font-size: 32px;
  font-weight: bold;
  margin: 0;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 页面标题部分 */
.page-header {
  background-color: #FFF5F0;
  padding: 1.5rem 0;
  text-align: center;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
  color: #FF631E;
}

/* 通用样式 */
.container {
  width: 1100px;
  margin: 0 auto;
  padding: 0.5rem 0;
}

/* 服务领域介绍部分 */
.practice-intro {
  background-color: white;
  padding: 1rem 0;
}

.intro-text {
  font-size: 2.6rem;
  line-height: 1.6;
  font-weight: 800;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  color: #FF631E
}

/* 服务卡片部分 */
.services-cards-section {
  padding: 4rem 0;
  background-color: #f8f9fa;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.service-card:hover::before {
  opacity: 1;
}

.card-header {
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  padding: 2rem 1.5rem;
  text-align: center;
  position: relative;
  z-index: 2;
}

.card-body {
  padding: 2rem 1.5rem;
  position: relative;
  z-index: 2;
}

.card-title {
  font-size: 2.1rem;
  font-weight: bold;
  color: white;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-text {
  list-style-type: none;
  padding-left: 0;
  color: #4a5568;
  margin: 0;
}

.card-text li {
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 0.8rem;
  padding-left: 1.5rem;
  position: relative;
  transition: color 0.2s ease;
}

.card-text li:last-child {
  margin-bottom: 0;
}

.card-text li::before {
  content: '•';
  color: #FF631E;
  font-weight: bold;
  font-size: 1.2rem;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}

.card-text li:hover {
  color: #2d3748;
}



/* 简化的高亮样式 */
.highlight {
  color: #FF631E !important;
  font-weight: 700 !important;
  /* background: rgba(255, 99, 30, 0.1) !important; */
  /* padding: 3px 8px !important;
  border-radius: 4px !important;
  border: 1px solid rgba(255, 99, 30, 0.3) !important; */
  display: inline !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 992px) {
  .banner-section {
    height: 400px;
  }

  .page-title {
    font-size: 1.6rem;
  }

  .banner-title {
    font-size: 36px;
  }

  .banner-subtitle {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .banner-section {
    height: 300px;
  }

  .page-title {
    font-size: 1.4rem;
  }

  .banner-title {
    font-size: 32px;
  }

  .banner-subtitle {
    font-size: 24px;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  .intro-text {
    font-size: 1.8rem;
  }

  .services-cards-section {
    padding: 3rem 0;
  }
}

@media (max-width: 576px) {
  .banner-section {
    height: 250px;
  }

  .page-title {
    font-size: 1.3rem;
  }

  .banner-title {
    font-size: 28px;
  }

  .banner-subtitle {
    font-size: 20px;
  }

  .intro-text {
    font-size: 1.5rem;
  }

  .card-header {
    padding: 1.5rem 1rem;
  }

  .card-body {
    padding: 1.5rem 1rem;
  }

  .card-title {
    font-size: 1.5rem;
  }

  .card-text li {
    font-size: 0.9rem;
  }

  .services-cards-section {
    padding: 2rem 0;
  }
}

@media (max-width: 360px) {
  .card-header {
    padding: 1.2rem 0.8rem;
  }

  .card-body {
    padding: 1.2rem 0.8rem;
  }

  .card-title {
    font-size: 1.3rem;
  }

  .card-text li {
    font-size: 0.85rem;
    padding-left: 1.2rem;
  }

  .intro-text {
    font-size: 1.3rem;
  }
}

/* 专利战略规划模块样式 */
.patent-strategy-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  position: relative;
}

.patent-strategy-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots3" width="30" height="30" patternUnits="userSpaceOnUse"><circle cx="15" cy="15" r="2" fill="%23e2e8f0" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23dots3)"/></svg>');
  pointer-events: none;
}

.patent-strategy-section .section-header {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 1;
}

.strategy-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.strategy-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  border-radius: 2px;
}

.strategy-content {
  display: grid;
  grid-template-columns: 39% 59%;
  gap: 2rem;
  align-items: start;
  position: relative;
  z-index: 1;
}

.strategy-image {
  position: relative;
}

.strategy-img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* 弹窗样式 */
.contact-dialog .el-dialog__header {
  display: none;
}

.contact-dialog .el-dialog__body {
  padding: 0;
  border-radius: 15px;
}

.dialog-content {
  padding: 2rem 2.5rem;
  background: #f8f9fa;
}

.dialog-header {
  text-align: center;
  margin-bottom: 2rem;
}

.dialog-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.dialog-subtitle {
  font-size: 1rem;
  color: #666;
}

.dialog-body {
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
}

.dialog-body .image-gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 0 0 420px;
}

.gallery-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  text-align: left;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.gallery-item img {
  width: 18.75rem;
  /* 300px */
  border-radius: 8px;
  flex-shrink: 0;
}

.gallery-image {
  height: 9.375rem;
  /* 150px */
  object-fit: contain;
}

.gallery-item .item-caption {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.dialog-body .text-content {
  flex: 1;
  min-width: 0;
  text-align: justify;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #555;
}

.dialog-body .text-content p {
  margin-bottom: 1rem;
}

.dialog-footer {
  text-align: center;
  margin-top: 0rem;
}

.strategy-img:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.strategy-text {
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  position: relative;
}

.strategy-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 20px;
  z-index: 1;
}

.strategy-text:hover::before {
  opacity: 1;
}

.text-section {
  margin-bottom: 2.5rem;
  position: relative;
  z-index: 2;
}

.text-section:last-child {
  margin-bottom: 0;
}

.section-subtitle {
  font-size: 1.4rem;
  font-weight: 600;
  color: #FF631E;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 1rem;
}

.section-subtitle::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 2px;
}

.section-content {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a5568;
  text-align: justify;
  margin: 0;
}

/* 响应式设计 - 专利战略规划模块 */
@media (max-width: 1024px) {
  .strategy-content {
    grid-template-columns: 45% 55%;
    gap: 2rem;
  }

  .strategy-title {
    font-size: 2.2rem;
  }

  .strategy-text {
    padding: 2.5rem;
  }
}

@media (max-width: 768px) {
  .patent-strategy-section {
    padding: 4rem 0;
  }

  .strategy-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .strategy-title {
    font-size: 1.8rem;
  }

  .strategy-text {
    padding: 2rem;
  }

  .section-subtitle {
    font-size: 1.2rem;
  }

  .section-content {
    font-size: 0.95rem;
  }
}

@media (max-width: 576px) {
  .patent-strategy-section {
    padding: 3rem 0;
  }

  .strategy-title {
    font-size: 1.5rem;
  }

  .strategy-text {
    padding: 1.5rem;
  }

  .section-subtitle {
    font-size: 1.1rem;
  }

  .section-content {
    font-size: 0.9rem;
    line-height: 1.7;
  }

  .text-section {
    margin-bottom: 2rem;
  }
}

@media (max-width: 360px) {
  .strategy-title {
    font-size: 1.3rem;
  }

  .strategy-text {
    padding: 1.2rem;
  }

  .section-subtitle {
    font-size: 1rem;
    padding-left: 0.8rem;
  }

  .section-content {
    font-size: 0.85rem;
  }
}

/* 药品专利链接制度模块样式 */
.pharma-patent-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
}

.pharma-patent-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="pharma-dots" width="40" height="40" patternUnits="userSpaceOnUse"><circle cx="20" cy="20" r="1.5" fill="%23FF631E" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23pharma-dots)"/></svg>');
  pointer-events: none;
}

.pharma-patent-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.pharma-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.pharma-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  border-radius: 2px;
}

.pharma-description {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 1;
}

.description-text {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #4a5568;
  margin: 0 auto;
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  position: relative;
}

.description-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 16px;
  z-index: 1;
}

.description-text:hover::before {
  opacity: 1;
}

.certificates-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  position: relative;
  z-index: 1;
}

.certificate-item {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
}

.certificate-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 99, 30, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.certificate-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.certificate-item:hover::before {
  opacity: 1;
}

.certificate-image {
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.cert-img {
  width: 100%;
  height: 36rem;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.certificate-item:hover .cert-img {
  transform: scale(1.02);
}

.certificate-caption {
  padding: 2rem;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cert-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #FF631E;
  margin: 0;
  line-height: 1.5;
  position: relative;
  padding-top: 1rem;
}

.showcase-cta {
  text-align: center;
  margin-top: 2rem;
  /* margin-bottom: 2rem; */
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

.cert-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  border-radius: 2px;
}

/* 响应式设计 - 药品专利链接制度模块 */
@media (max-width: 1024px) {
  .pharma-title {
    font-size: 2.4rem;
  }

  .description-text {
    font-size: 1.1rem;
    padding: 2rem;
  }

  .certificates-grid {
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .pharma-patent-section {
    padding: 4rem 0;
  }

  .pharma-title {
    font-size: 2rem;
  }

  .description-text {
    font-size: 1rem;
    padding: 1.5rem;
  }

  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .certificate-caption {
    padding: 1.5rem;
  }

  .cert-text {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .pharma-patent-section {
    padding: 3rem 0;
  }

  .pharma-title {
    font-size: 1.6rem;
  }

  .description-text {
    font-size: 0.95rem;
    padding: 1.2rem;
    line-height: 1.7;
  }

  .certificate-caption {
    padding: 1.2rem;
  }

  .cert-text {
    font-size: 0.9rem;
  }
}

@media (max-width: 360px) {
  .pharma-title {
    font-size: 1.4rem;
  }

  .description-text {
    font-size: 0.9rem;
    padding: 1rem;
  }

  .certificate-caption {
    padding: 1rem;
  }

  .cert-text {
    font-size: 0.85rem;
  }
}

/* 授权周期快模块样式 */
.fast-authorization-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
  position: relative;
}

.fast-authorization-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="auth-dots" width="35" height="35" patternUnits="userSpaceOnUse"><circle cx="17.5" cy="17.5" r="1.8" fill="%23FF631E" opacity="0.08"/></pattern></defs><rect width="100" height="100" fill="url(%23auth-dots)"/></svg>');
  pointer-events: none;
}

.fast-authorization-section .section-header {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 1;
}

.authorization-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.authorization-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  border-radius: 2px;
}

.authorization-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  position: relative;
  z-index: 1;
}

.authorization-item {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
  display: flex;
  flex-direction: column;
}

.authorization-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 99, 30, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.authorization-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.authorization-item:hover::before {
  opacity: 1;
}

.auth-image {
  position: relative;
  overflow: hidden;
  z-index: 2;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.auth-img {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.authorization-item:hover .auth-img {
  transform: scale(1.05);
}

.auth-content {
  padding: 2rem;
  text-align: center;
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  border-top: 1px solid rgba(255, 99, 30, 0.1);
}

.auth-text {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FF631E;
  margin: 0;
  line-height: 1.4;
  position: relative;
}

.auth-text::before {
  content: '';
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
}

/* 响应式设计 - 授权周期快模块 */
@media (max-width: 1024px) {
  .authorization-title {
    font-size: 2.4rem;
  }

  .authorization-grid {
    gap: 2rem;
  }

  .auth-image {
    padding: 1.5rem;
  }

  .auth-content {
    padding: 1.5rem;
  }

  .auth-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 768px) {
  .fast-authorization-section {
    padding: 4rem 0;
  }

  .authorization-title {
    font-size: 2rem;
  }

  .authorization-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .auth-image {
    padding: 1.2rem;
  }

  .auth-img {
    max-height: 250px;
  }

  .auth-content {
    padding: 1.2rem;
  }

  .auth-text {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .fast-authorization-section {
    padding: 3rem 0;
  }

  .authorization-title {
    font-size: 1.6rem;
  }

  .auth-image {
    padding: 1rem;
  }

  .auth-img {
    max-height: 200px;
  }

  .auth-content {
    padding: 1rem;
  }

  .auth-text {
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  .authorization-title {
    font-size: 1.4rem;
  }

  .auth-image {
    padding: 0.8rem;
  }

  .auth-img {
    max-height: 180px;
  }

  .auth-content {
    padding: 0.8rem;
  }

  .auth-text {
    font-size: 0.9rem;
  }
}

.highlight-blue {
  color: #FF631E;
  font-weight: 600;
}

/* 弹窗移动端优化样式 */
@media (max-width: 640px) {
  /* 平板端优化 */
  .contact-dialog .el-dialog {
    width: 90% !important;
    margin: 0 auto;
    top: 2vh !important;
  }

  .dialog-content {
    padding: 2rem 1.5rem;
  }

  .dialog-title {
    font-size: 1.8rem;
    line-height: 1.3;
  }

  .dialog-body {
    flex-direction: column;
    gap: 2rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: row;
    text-align: left;
    padding: 1rem;
    gap: 1rem;
  }

  .gallery-item img {
    width: 120px;
    max-width: 120px;
    flex-shrink: 0;
  }

  .gallery-image {
    height: 80px;
  }

  .gallery-item .item-caption {
    margin-top: 0;
    margin-left: 0;
    font-size: 0.95rem;
    flex: 1;
    display: flex;
    align-items: center;
  }
}

@media (max-width: 480px) {
  /* 移动端优化 */
  .contact-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
    top: 1vh !important;
    max-height: 95vh;
  }

  .contact-dialog .el-dialog__body {
    max-height: 85vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog-content {
    padding: 1.5rem 1rem;
  }

  .dialog-title {
    font-size: 1.5rem;
    line-height: 1.4;
    margin-bottom: 1rem;
  }

  .dialog-body {
    gap: 1.5rem;
  }

  .dialog-body .text-content {
    font-size: 0.9rem;
    line-height: 1.7;
  }

  .gallery-item {
    padding: 0.8rem;
    margin-bottom: 0.8rem;
    border-radius: 8px;
    flex-direction: column;
    text-align: center;
  }

  .gallery-item img {
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
  }

  .gallery-image {
    height: 120px;
  }

  .gallery-item .item-caption {
    margin-top: 0.8rem;
    margin-left: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #FF631E;
  }

  .dialog-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
  }

  .dialog-footer .el-button {
    width: 100%;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  /* 小屏幕移动端优化 */
  .contact-dialog .el-dialog {
    width: 98% !important;
  }

  .dialog-content {
    padding: 1rem 0.8rem;
  }

  .dialog-title {
    font-size: 1.3rem;
    line-height: 1.3;
  }

  .dialog-body .text-content {
    font-size: 0.85rem;
    line-height: 1.6;
  }

  .gallery-item {
    padding: 0.6rem;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    font-size: 0.85rem;
    margin-top: 0.6rem;
  }
}

/* 弹窗动画效果 */
.contact-dialog .el-dialog {
  animation: dialogSlideIn 0.3s ease-out;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 图片加载动画 */
.gallery-item img {
  transition: all 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.02);
}

/* 触摸友好的按钮样式 */
@media (max-width: 768px) {
  .gallery-item {
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 99, 30, 0.1);
    tap-highlight-color: rgba(255, 99, 30, 0.1);
  }

  .gallery-item:active {
    transform: scale(0.98);
    background-color: rgba(255, 99, 30, 0.05);
  }

  .dialog-footer .el-button {
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
  }

  .dialog-footer .el-button:active {
    transform: scale(0.98);
  }
}

/* 滚动条样式优化 */
.contact-dialog .el-dialog__body::-webkit-scrollbar {
  width: 4px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #FF631E;
  border-radius: 2px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #e55a1a;
}

/* 文本选择优化 */
.dialog-content {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

/* 高亮文本移动端优化 */
.highlight-blue {
  padding: 2px 4px;
  border-radius: 3px;
}

@media (max-width: 480px) {
  .highlight-blue {
    padding: 1px 3px;
    font-size: 0.9em;
  }
}
</style>